module.exports = __webpack_public_path__ + "img/VL_04_01.b72021b4.png";